import React from "react";

const TrackingOrder = ({ size="40", fill = "#BEBEBE" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1025_605)">
        <path
          d="M15.365 21.09L19.325 14.25C20.405 13.185 21 11.77 21 10.25C21 7.15 18.475 4.625 15.375 4.625C12.275 4.625 9.75 7.15 9.75 10.25C9.75 11.74 10.325 13.14 11.375 14.2L15.365 21.09ZM15.375 6.125C17.65 6.125 19.5 7.975 19.5 10.25C19.5 11.39 19.04 12.45 18.21 13.24L18.13 13.315L15.36 18.1L12.565 13.275L12.49 13.205C11.685 12.42 11.245 11.375 11.245 10.255C11.245 7.98 13.095 6.13 15.37 6.13L15.375 6.125Z"
          fill={fill}
        />
        <path
          d="M15.375 13.03C16.91 13.03 18.155 11.78 18.155 10.25C18.155 8.71997 16.905 7.46997 15.375 7.46997C13.845 7.46997 12.595 8.71997 12.595 10.25C12.595 11.78 13.845 13.03 15.375 13.03ZM15.375 8.96997C16.08 8.96997 16.655 9.54497 16.655 10.25C16.655 10.955 16.08 11.53 15.375 11.53C14.67 11.53 14.095 10.955 14.095 10.25C14.095 9.54497 14.67 8.96997 15.375 8.96997Z"
          fill={fill}
        />
        <path d="M11.5 32.625H10.75V34.125H11.5V32.625Z" fill={fill} />
        <path d="M14 32.625H12.75V34.125H14V32.625Z" fill={fill} />
        <path d="M16.75 32.625H15.25V34.125H16.75V32.625Z" fill={fill} />
        <path d="M16.75 24.48H15.25V25.835H16.75V24.48Z" fill={fill} />
        <path d="M16.75 27.1949H15.25V28.5499H16.75V27.1949Z" fill={fill} />
        <path d="M16.75 29.91H15.25V31.265H16.75V29.91Z" fill={fill} />
        <path d="M16.75 21.625H15.25V23.125H16.75V21.625Z" fill={fill} />
        <path d="M22.35 21.625H20.95V23.125H22.35V21.625Z" fill={fill} />
        <path d="M19.55 21.625H18.15V23.125H19.55V21.625Z" fill={fill} />
        <path d="M25.25 21.625H23.75V23.125H25.25V21.625Z" fill={fill} />
        <path d="M25.25 9.625H23.75V11.125H25.25V9.625Z" fill={fill} />
        <path d="M25.25 18.625H23.75V20.125H25.25V18.625Z" fill={fill} />
        <path d="M25.25 12.625H23.75V14.125H25.25V12.625Z" fill={fill} />
        <path d="M25.25 15.625H23.75V17.125H25.25V15.625Z" fill={fill} />
        <path d="M25.25 6.625H23.75V8.125H25.25V6.625Z" fill={fill} />
        <path d="M27.75 6.625H26.5V8.125H27.75V6.625Z" fill={fill} />
        <path d="M29.75 6.625H29V8.125H29.75V6.625Z" fill={fill} />
        <path
          d="M34.5 3.625C32.43 3.625 30.75 5.305 30.75 7.375C30.75 9.445 32.43 11.125 34.5 11.125C36.57 11.125 38.25 9.445 38.25 7.375C38.25 5.305 36.57 3.625 34.5 3.625ZM34.5 9.625C33.26 9.625 32.25 8.615 32.25 7.375C32.25 6.135 33.26 5.125 34.5 5.125C35.74 5.125 36.75 6.135 36.75 7.375C36.75 8.615 35.74 9.625 34.5 9.625Z"
          fill={fill}
        />
        <path
          d="M34.5 8.375C35.0523 8.375 35.5 7.92728 35.5 7.375C35.5 6.82272 35.0523 6.375 34.5 6.375C33.9477 6.375 33.5 6.82272 33.5 7.375C33.5 7.92728 33.9477 8.375 34.5 8.375Z"
          fill={fill}
        />
        <path
          d="M5.71997 29.375C3.64997 29.375 1.96997 31.055 1.96997 33.125C1.96997 35.195 3.64997 36.875 5.71997 36.875C7.78997 36.875 9.46997 35.195 9.46997 33.125C9.46997 31.055 7.78997 29.375 5.71997 29.375ZM5.71997 35.375C4.47997 35.375 3.46997 34.365 3.46997 33.125C3.46997 31.885 4.47997 30.875 5.71997 30.875C6.95997 30.875 7.96997 31.885 7.96997 33.125C7.96997 34.365 6.95997 35.375 5.71997 35.375Z"
          fill={fill}
        />
        <path
          d="M5.71997 34.125C6.27226 34.125 6.71997 33.6773 6.71997 33.125C6.71997 32.5727 6.27226 32.125 5.71997 32.125C5.16769 32.125 4.71997 32.5727 4.71997 33.125C4.71997 33.6773 5.16769 34.125 5.71997 34.125Z"
          fill={fill}
        />
        <path d="M3.25 3.625H9.75V2.125H1.75V9.625H3.25V3.625Z" fill={fill} />
        <path d="M35.5 36.375H29V37.875H37V30.375H35.5V36.375Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_1025_605">
          <rect width={size} height={size} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrackingOrder;
